/**
 * Module dependencies.
 */

import React, { ReactNode, createContext, useContext } from 'react';
import { CrudTemplate } from './form-types';

/**
 * `Props` type.
 */

type Props<T> = {
  template: CrudTemplate<T>;
  children: ReactNode;
};

/**
 * `CrudTemplateContext` context.
 */

const CrudTemplateContext = createContext<{ template: CrudTemplate<any> }>({
  template: null as any
});

/**
 * Export `useTemplate`.
 */

export function useTemplate() {
  return useContext(CrudTemplateContext);
}

/**
 * Export `CrudTemplateProvider` component.
 */

export function CrudTemplateProvider<T>({ template, children }: Props<T>): JSX.Element {
  return <CrudTemplateContext.Provider value={{ template }}>{children}</CrudTemplateContext.Provider>;
}
